import { useEffect, useState } from 'react'
import api from '../api/client'

export default function Dashboard () {
  const [tenants, setTenants] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get('/tenants').then(res => setTenants(res.data.data)).finally(() => setLoading(false))
  }, [])

  const active = tenants.filter(t => t.status === 'active').length
  const totalUsers = tenants.reduce((s, t) => s + parseInt(t.active_users || 0), 0)
  const totalWarehouses = tenants.reduce((s, t) => s + parseInt(t.active_warehouses || 0), 0)

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Dashboard Sistema</div><div className="page-subtitle">Visión global de todas las empresas</div></div>
      </div>
      <div className="page-body">
        {loading ? <div className="loading">Cargando...</div> : (
          <>
            <div className="stats-grid">
              <div className="stat-card"><div className="stat-value">{tenants.length}</div><div className="stat-label">🏢 Empresas totales</div></div>
              <div className="stat-card"><div className="stat-value">{active}</div><div className="stat-label">✅ Empresas activas</div></div>
              <div className="stat-card"><div className="stat-value">{totalUsers}</div><div className="stat-label">👥 Usuarios activos</div></div>
              <div className="stat-card"><div className="stat-value">{totalWarehouses}</div><div className="stat-label">🏭 Almacenes activos</div></div>
            </div>

            <div className="card">
              <div className="card-header"><h3 className="card-title">Empresas registradas</h3></div>
              <div className="table-wrapper">
                <table>
                  <thead><tr><th>Empresa</th><th>Slug</th><th>Email</th><th>Plan</th><th>Usuarios</th><th>Almacenes</th><th>Estado</th></tr></thead>
                  <tbody>
                    {tenants.map(t => (
                      <tr key={t.id}>
                        <td><strong>{t.name}</strong></td>
                        <td><code>{t.slug}</code></td>
                        <td>{t.email}</td>
                        <td><span className={`badge ${t.plan === 'premium' ? 'badge-warning' : 'badge-info'}`}>{t.plan}</span></td>
                        <td>{t.active_users}</td>
                        <td>{t.active_warehouses}</td>
                        <td><span className={`badge ${t.status === 'active' ? 'badge-success' : 'badge-neutral'}`}>{t.status}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}
